import { Target, Users } from 'lucide-react'

import FbButton from 'components/FbUI/FbButton'

interface CampaignContactsZeroStateProps {
  hasContactRequests: boolean
  onSwitchToTargets: () => void
  variant: 'assign-targets' | 'request-contacts'
}

export function CampaignContactsZeroState({
  hasContactRequests,
  onSwitchToTargets,
  variant,
}: CampaignContactsZeroStateProps) {
  if (variant === 'assign-targets') {
    return (
      <div className="rounded-lg border border-line bg-surface p-12 text-center">
        <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-surface-alt">
          <Users className="size-7 text-fg-muted" />
        </div>
        <p className="mb-1 text-base text-fg">Assign targets first</p>
        <p className="mx-auto mb-4 max-w-sm text-sm text-fg-secondary">
          Before requesting contacts, you need to assign a target list to this
          campaign.
        </p>
        <FbButton
          type="button"
          size="sm"
          className="mx-auto gap-2"
          onClick={onSwitchToTargets}
        >
          <Target className="size-3.5" />
          Go to Targets
        </FbButton>
      </div>
    )
  }

  return (
    <div className="rounded-lg border border-line bg-surface p-12 text-center">
      <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-brand/5">
        <Users className="size-7 text-brand" />
      </div>
      <p className="mb-1 text-base text-fg">Request contacts</p>
      <p className="mx-auto mb-4 max-w-sm text-sm text-fg-secondary">
        This campaign has targets, but contacts have not been requested yet.
      </p>
      {hasContactRequests ? (
        <p className="text-sm text-fg-secondary">
          Use the Actions menu to request contacts for this campaign.
        </p>
      ) : (
        <p className="text-sm text-fg-secondary">
          Contact requests are not available for this campaign type.
        </p>
      )}
    </div>
  )
}
